import React, { Component } from 'react';
import PairDatePicker from './PairDatePicker';
import TokenDisplay from './TokenDisplay';
import StrikesTable from './StrikesTable';
import Underwrite from './Underwrite';
import Auction from './Auction';
import MessageCard from "./MessageCard";

class Market extends Component {

  state = {
    pair: "",
    tab: 0
  }

  setPairDate(pairdate) {
    this.setState({
      pair: pairdate.pair,
      date: pairdate.date,
      selected: null
    })
  }

  render() { //eslint-disable-line complexity
    var { pair, date, selected } = this.state;
    return (
      <div>
          <div style={{display:'flex', flexDirection:'row', paddingBottom:'20px', paddingTop:'10px'}}>
            <PairDatePicker onChange={(pd)=>this.setPairDate(pd)}/>
            {pair && (
              <div style={({flex:1, display:'flex', flexDirection:'column', justifyContent:'center'})}>
              <div style={({display:'flex', flexDirection:'row', marginLeft:'10px', justifyContent:'space-evenly'})}>
                <TokenDisplay token={pair.target}/>
                <TokenDisplay token={pair.currency}/>
              </div>
              </div>
            )}
          </div>
      {
        pair && date && (
          <div style={({display:'flex', flexDirection:'row'})}>
            <div style={({flex:1})}>
              <StrikesTable pair={pair} date={date} select={strike => this.setState({selected:strike})} selected={selected}/>
            </div>
            <div style={{flex:1, display:'flex', flexDirection:'column', justifyContent:'space-evenly'}}>
            {selected ?
              <div style={{flex:1, display:'flex', flexDirection:'column', justifyContent:'space-evenly'}}>
                <div style={{justifyContent:'center', display:'flex'}}>
                  <Auction strike={selected.strike} type={selected.type}/>
                </div>
                <div style={{justifyContent:'center', display:'flex'}}>
                  <Underwrite strike={selected.strike} type={selected.type}/>
                </div>
              </div> : 
             <MessageCard flexDirection='column' icon='priority_high' message='Please Select An Option From the Market Table'/>
            }
             </div>
         </div>
        )
      }
      </div>
    );
  }
}

export default Market;


// WEBPACK FOOTER //
// ./src/Market.js